import React from "react";
import "./Features.css";
import { FaBriefcase, FaShieldAlt, FaClock, FaCheckCircle, } from "react-icons/fa";

const Features = () => {
  return (
    <div className="features-wrapper">

      <div className="features-card">

        <div className="feature-item">
          <FaBriefcase className="feature-icon" />
          <p>1.5k+ Top Clients</p>
        </div>

        <div className="mobile-divider"></div>

        <div className="feature-item">
          <FaShieldAlt className="feature-icon" />
          <p>ISO 14001:2015 Certified</p>
        </div>
        <div className="mobile-divider"></div>

        <div className="feature-item">
          <FaClock className="feature-icon" />
          <p>25+ Years Experience</p>
        </div>
        <div className="mobile-divider"></div>

        <div className="feature-item">
          <FaCheckCircle className="feature-icon" />
          <p>Government Approved</p>
        </div>
      </div>
    </div>


  );
};

export default Features;